import { SxProps, Theme } from '@mui/material';
import { CrmColors } from '../../crm-theme';

export const closedTitleSx = (cc: CrmColors): SxProps<Theme> => ({
    fontSize: 11,
    fontWeight: 700,
    color: cc.textMuted,
    textTransform: 'uppercase',
    px: 0.5,
});

/// Esmaecido e com a borda da cor do desfecho: o encerrado não compete com os abertos.
export const closedCardSx = (cc: CrmColors, outcomeColor: string): SxProps<Theme> => ({
    px: 1.25,
    py: 1,
    borderRadius: '10px',
    border: `1px solid ${cc.border}`,
    borderLeft: `3px solid ${outcomeColor}`,
    background: cc.surfaceBg,
    opacity: 0.8,
    cursor: 'pointer',
    '&:hover': { opacity: 1, borderColor: cc.borderHover },
});
